module.exports = __webpack_public_path__ + "img/certificate03-2-3.1ad6349c.jpg";